import { gql, useMutation } from '@apollo/client';

import { Server } from '../../apollo/types';

interface SessionIntention {
  shortId: string;
  appointmentShortId: string;
  clientUserShortId: string;
  providerShortId: string;
  contentText: string;
  contentImageUrl: string | null;
  notificationCadence: string | null;
  notificationTimeOfDay: string | null;
  expiredAt: string | null;
}

interface UpdateSessionIntentionData {
  updateSessionIntention: {
    sessionIntention: SessionIntention;
  };
}

interface UpdateSessionIntentionVariables {
  sessionIntentionShortId: string;
  contentText?: string;
}

const updateSessionIntentionDocument = gql`
  mutation UpdateSessionIntention($sessionIntentionShortId: String!, $contentText: String) {
    updateSessionIntention(sessionIntentionShortId: $sessionIntentionShortId, contentText: $contentText) {
      sessionIntention {
        shortId
        appointmentShortId
        clientUserShortId
        providerShortId
        contentText
        contentImageUrl
        notificationCadence
        notificationTimeOfDay
        expiredAt
      }
    }
  }
`;

export function useUpdateSessionIntentionMutation() {
  return useMutation<UpdateSessionIntentionData, UpdateSessionIntentionVariables>(updateSessionIntentionDocument, {
    context: {
      server: Server.MONOLITH,
    },
  });
}
